declare var swal: any;
import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, GuardianInfoController, GuardianInfoRequest, SaveCustomerMessageRequest, CustomerMessageRequest, CustomerMessageController, OTFormDetailByReportCodeController, OTFormDetailByReportCodeRequest, SectionData, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, FollicularScansByCycleController, FollicularScansByCycleRequest, FollicularScanDetailsByCodeController, FollicularScanDetailsByCodeRequest, FollicularScanDetailController, FollicularScanDetailRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest, IvfTreatmentPlanController, IvfTreatmentPlanRequest, DeleteFollicularScanRequest, GenericProcPostRequest, S_Methods, TreatmentCycleStatusController, TreatmentCycleStatusRequest } from '../../../../models/actor/actor';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//import { NgbdUploadActorImageModal } from '../../../../../modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorPersonalInfoController, ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppFeaturesList } from '../../../../constants/constants';
//import  './profilesteps.js';
import { HCPService } from '../../../../services/hcp.service';
declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { NgbTcDetailsModal } from './tcdetails.modal';
import { NgbEventAddModal } from './eventadd.modal';
import { FdActorReportsDocController, FDActorDocRequest } from '../../../../../../../src/app/ncs/models/formdesign/fd.model';
import { FDService } from '../../../../../../../src/app/ncs/services/fd.service';
import { NgbViewMedicineTestModal } from './viewmedicinetest.modal';
import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';
import { NgbFollicularEditModal } from './follicularedit.modal';

@Component({
  selector: 'follicularscan2',
  templateUrl: './follicularscan2.component.html',
  styleUrls: ['./follicularscan2.component.scss'],
  animations: [routerTransition()]
})

export class FollicularScan2Component implements OnInit {
    @Output() GoFollicle: EventEmitter<any> = new EventEmitter();
  //Variable Declaration
  currentPage: string = "About"
  public isRequesting: boolean = false;
 
  //CurrentFdActorReportsDocController: FdActorReportsDocController[];
  //CurrentFDActorDocRequest: FDActorDocRequest;
  public ApiResData: ApiResponseModel;

 

  @Input() NurseActorCode: number = 0;
  @Input() ActorCode: number;
  @Input() CycleCode: number;
    @Input() Duration: number;
    @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Input() FormattedCode: number;
    @Input() DisplayName: string;
    @Input() LMPDate: Date;
    @Input() GradingModel: string;
  searchTitle: string;
  //
  //public FormattedCode: number = 0;
  public IsSetAccessRights: boolean;
  public CanEditProfileInfo: number = 0;
  public CanEditContactInfo: number = 0;
  public CanShowProfileInfo: number = 0;
  public CanShowContactInfo: number = 0;
  public Code: string;

  public CanShowProfileSummary: number = 0;
  public CanEditProfileSummary: number = 0;

  public CanShowJobPreferences: number = 0;
  public CanEditJobPreferences: number = 0;

  public CanShowEducation: number = 0;
  public CanEditEducation: number = 0;

  public CanShowEmploymentHistory: number = 0;
  public CanEditEmploymentHistory: number = 0;

  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;

  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;

  public CanShowCertifications: number = 0;
  public CanEditCertifications: number = 0;

  public CanShowMedicalFitness: number = 0;
  public CanEditMedicalFitness: number = 0;

  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;

  public CanShowLegalinfo: number = 0;
  public CanEditLegalinfo: number = 0;
  public showprofile: boolean = true;
  public showmessages: boolean = false;
 // public LMPDate: Date;
  //
    CurrentFollicularScanDetailController: FollicularScanDetailController[];
    FollicularScanEndInfo: FollicularScanDetailController;
    CurrentFollicularScanDetailRequest: FollicularScanDetailRequest;

    LoadScansData() {
        //alert("ScansData")
        this.CurrentFollicularScanDetailRequest = new FollicularScanDetailRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentFollicularScanDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetFollicularScanDetailController();
    }

    GetFollicularScanDetailController() {
        this.StartRefreshing();
        this.CurrentFollicularScanDetailRequest.ConditionalOperator = 20;
        this.CurrentFollicularScanDetailRequest.ScanCode = 0;
        this.CurrentFollicularScanDetailRequest.CycleCode = this.CycleCode;
        this.CurrentFollicularScanDetailRequest.PatientCode = 0;

        //alert(this.FormattedCode);
        this.actorservice.GetFollicularScanDetailController(this.CurrentFollicularScanDetailRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentFollicularScanDetailController = this.ApiResData.Result;
                    this.FollicularScanEndInfo = this.CurrentFollicularScanDetailController[0];

                   
                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();

                    this.LoadOvaryData();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentFollicularScanOvaryDetailController: FollicularScanOvaryDetailController[];
    FollicularScanInfo: FollicularScanOvaryDetailController;
    CurrentFollicularScanOvaryDetailRequest: FollicularScanOvaryDetailRequest;

    LoadOvaryData() {
        //alert("ScansData")
        this.CurrentFollicularScanOvaryDetailRequest = new FollicularScanOvaryDetailRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentFollicularScanOvaryDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetFollicularScanOvaryDetailController();
    }

  GetOvaryDetails(fg: number, pos: string): FollicularScanOvaryDetailController[]{
    //alert(fg);
    //alert(pos);
        return this.CurrentFollicularScanOvaryDetailController.filter(
            function (v, i, d) {
                return v.FollicularGrowth == fg && v.OvarPos == pos;
            }
        );

    }
    

    GetFollicularScanOvaryDetailController() {
        this.StartRefreshing();
        this.CurrentFollicularScanOvaryDetailRequest.ConditionalOperator = 20;
        this.CurrentFollicularScanOvaryDetailRequest.ScanCode = 0;
        this.CurrentFollicularScanOvaryDetailRequest.CycleCode = this.CycleCode;
        this.CurrentFollicularScanOvaryDetailRequest.PatientCode = 0;

        //alert(this.FormattedCode);
        this.actorservice.GetFollicularScanOvaryDetailController(this.CurrentFollicularScanOvaryDetailRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentFollicularScanOvaryDetailController = this.ApiResData.Result;
                  this.FollicularScanInfo = this.CurrentFollicularScanOvaryDetailController[0];
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                  this.stopRefreshing();
                  this.LoadIvfAdditionalDetails("Follicular Scans");
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  LoadIvfAdditionalDetails(addDetails: string) {





  }
    GetCycleCode(fg: number): FollicularScanOvaryDetailController[] {
        return this.CurrentFollicularScanOvaryDetailController.filter(
            function (v, i, d) {
                return v.FollicularGrowth == fg
            }
        );

    }
  
 
  constructor(private router: Router, public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService, private hcpservice: HCPService, private fdservice: FDService, private tosterservice: NGXToastrService,
    private modalService: NgbModal) {

    //stepObject.init();
    //webGlObject.init();
  }


  ngOnInit() {
    this.LoadCycles();
        this.LoadScansData(); 
        this.LoadPatients();
        this.LoadPlan(this.CycleCode);
        
    //alert(this.ActorCode);
    //alert(this.CycleCode);
    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');
   
   
    //this.LoadPatients();
    ///this.LoadClinics();
    //this.LoadMessages();
   
  

    //alert(this.ActorCode);

   
    // Horizontal Timeline js for user timeline
    //$.getScript('./assets/js/vertical-timeline.js');
    //



  }
  

  

  

 
  
  //
 
  //
  CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
  ScanData: TreatmentCycleStatusController[];
  ScanData2: TreatmentCycleStatusController;
  CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
  LoadCycles() {
    this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
    this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.CycleCode;
    this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCycleStatusController();
  }
  GetTreatmentCycleStatusController() {
    this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
          this.ScanData = this.ApiResData.Result;
          var Scanlist = this.ScanData.filter(
            function (c) {
              return c.PhaseActivity == "Follicular Scans";
            });
          this.ScanData = Scanlist;
          this.ScanData2 = this.ScanData[0];
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
    CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
    SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;

    CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
    LoadPatients() {
        this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = this.ActorCode;
        this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesByActorCodeController();
    }

    GetTreatmentCyclesByActorCodeController() {
        this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
                    this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
                    //this.LMPDate = this.SelectedTreatmentCycle.LMP;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                    this.LoadDSAData();
                    //this.LoadPlan();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
    // DSADetails: DSAActivityByCycleCodeController;
    //DSADetails: DSAActivityByCycleCodeController;
    CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;
    DSADetails: DSAActivityByCycleCodeController;
    LoadDSAData() {
        //alert("ScansData");
        this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.GetActorCode2(this.SelectedTreatmentCycle.EggSourceType, this.SelectedTreatmentCycle.RecepientType);
        this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
        this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetDSAActivityByCycleCodeController();
    }

    GetDSAActivityByCycleCodeController() {
        //this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;


        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
                    this.DSADetails = this.GetCycleActivity2(this.GetActorCode2(this.SelectedTreatmentCycle.EggSourceType, this.SelectedTreatmentCycle.RecepientType), this.SelectedTreatmentCycle.ProtocolStartDate)[0];
                    // this.DSADetails = this.GetCycleActivity(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.FollicularScanEndInfo.ScanDate)[0];
                    //alert(this.DSADetails);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

                    //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
                    //var list = this.CurrentDSAActivityByCycleCodeController.filter(


                    //    function (a) {
                    //        var Date = this.FollicularScanEndInfo.ScanDate;
                    //        var ActorCode = this.SelectedpatientDetails.ActorID;
                    //        return a.ActivityDate == Date && a.ActorCode == ActorCode
                    //    });

                    //this.CurrentDSAActivityByCycleCodeController = list;
                    //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
                    //alert(this.Doc1);
                    //alert(this.Antag);
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    GetActorCode2(EggSourceType: string, ReceipentType: string) {
       // alert(EggSourceType);
       // alert(ReceipentType);
        if (EggSourceType == 'Self' && ReceipentType == 'Self') {
            var ActorCode = this.SelectedTreatmentCycle.EggActorCode;
            return ActorCode;
        }
        else if (EggSourceType == 'Donor' && ReceipentType == 'Self') {
            var ActorCode = this.SelectedTreatmentCycle.EggActorCode;
            return ActorCode;
        }
        else if (EggSourceType == 'Self' && ReceipentType == 'Donor') {
            var ActorCode = this.SelectedTreatmentCycle.RecepientActorCode;
            return ActorCode;
        }
        else if (EggSourceType == 'Donor' && ReceipentType == 'Donor') {
            var ActorCode = this.SelectedTreatmentCycle.EggActorCode;
            return ActorCode;
        }

    }
    GetCycleActivity2(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
       // alert(ReceipientActorCode);
        //alert(TransferDateNew);
        return this.CurrentDSAActivityByCycleCodeController.filter(
            function (v, i, d) {

                return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
            }
        )

    }
    CurrentIvfTreatmentPlanController: IvfTreatmentPlanController[];
    PlanDetails: IvfTreatmentPlanController;
    CurrentIvfTreatmentPlanRequest: IvfTreatmentPlanRequest;
    LoadPlan(CycleCode: number) {
        this.CurrentIvfTreatmentPlanRequest = new IvfTreatmentPlanRequest();
        this.CurrentIvfTreatmentPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentIvfTreatmentPlanRequest.CycleCode = CycleCode;
        this.CurrentIvfTreatmentPlanRequest.ConditionalOperator = 10;
        this.CurrentIvfTreatmentPlanRequest.ActorCode = 0;


        this.GetIvfTreatmentPlanController();
    }
    GetIvfTreatmentPlanController() {
        this.StartRefreshing();
        //this.spinner.show();

        this.actorservice.GetIvfTreatmentPlanController(this.CurrentIvfTreatmentPlanRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    this.CurrentIvfTreatmentPlanController = this.ApiResData.Result;
                    this.PlanDetails = this.CurrentIvfTreatmentPlanController[0];
                    //this.CurrentCounsellingActivitiesByTimeController = this.ApiResData.Result;
                    //this.RefreshPatientsByDate();
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.spinner.hide();
                    this.stopRefreshing();
                    
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    
  
  
    AddFollicularEventDetails() {
        const modalRef = this.modalService.open(NgbEventAddModal,
            {
                centered: true,
                size: "lg"

            })
        modalRef.componentInstance.ActorCodeNew = this.ActorCode;
        modalRef.componentInstance.CycleCode = this.CycleCode;
        modalRef.componentInstance.Plancode = this.PlanDetails.FollowupPlanCode;
        modalRef.componentInstance.LMPDate = this.LMPDate;
        modalRef.componentInstance.ActivityName = "None";
        modalRef.componentInstance.Doc1 = this.DSADetails.DOC;
        modalRef.componentInstance.Antag = this.DSADetails.ANTAG;
        modalRef.componentInstance.Stimulation = this.DSADetails.STIMULATION;
        modalRef.componentInstance.TCModelName = this.SelectedTreatmentCycle.TCModelName;
        modalRef.componentInstance.ModalName = "newmodal";
       
        modalRef.result.then((val: string) => {
            //alert(val);
            if (val == "Load") {
                this.LoadScansData();
                this.GoFollicle.emit();
            }

        });
    }

    Editscan(s: FollicularScanDetailController) {
        const modalRef = this.modalService.open(NgbFollicularEditModal,
            {
                centered: true,
                size: "xl",
                keyboard: false,
                backdrop: 'static'

            })

        modalRef.componentInstance.CycleCode = this.CycleCode; /*this.GetCycleCode(s.FollicularGrowth)[0].TreatmentCycle*/
        modalRef.componentInstance.FollicularGrowthCode = s.FollicularGrowth;
        modalRef.componentInstance.ActivityCode = s.CycleActivity;
        modalRef.componentInstance.PatientCode = this.SelectedTreatmentCycle.EggPatientRegistrationNo;
        modalRef.componentInstance.Eggsourcetype = this.SelectedTreatmentCycle.EggSourceType;
        modalRef.componentInstance.ActorCode = this.ActorCode;
        modalRef.componentInstance.DOC = s.DOC;
        modalRef.componentInstance.GradingModel = this.GradingModel;
        modalRef.result.then((val: string) => {
            //alert(val);
            if (val == "Load") {
                this.LoadScansData();
                this.GoFollicle.emit();
            }
        });
    }
  DeleteFollicularScan(l) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.DeleteScan(l);

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })

  }
  DeleteScan(l) {
    var saveReq = new DeleteFollicularScanRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 80160;
    saveReq.EmpActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.CycleCode = this.CycleCode;
    saveReq.FollicularGrowthCode = l.FollicularGrowth;
    saveReq.ActivityCode = l.CycleActivity;
    saveReq.PatientCode = this.SelectedTreatmentCycle.EggPatientRegistrationNo;
    saveReq.EggSourceType = this.SelectedTreatmentCycle.EggSourceType;
    saveReq.ActorCode = this.ActorCode;
    saveReq.DOC = l.DOC;
    saveReq.GradingModel = this.GradingModel;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 80160;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.LoadScansData();
            //this.activeModal.close();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
   


  
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
 
  closeResult: string;
  // This function is used in open
 
  // Open content with dark section
  //openContent() {
  //  alert('open dialog');
  //  if (this.CurrentActorProfileController.ActorImageCode != null && this.CurrentActorProfileController.ActorImageCode > 0) {
  //    const modalRef = this.modalService.open(NgbdUploadActorImageModal, {
  //      centered: true
  //    })
  //    modalRef.componentInstance.ActorImageCode = this.CurrentActorProfileController.ActorImageCode;
  //    modalRef.componentInstance.ActorCode = this.CurrentActorProfileController.ActorCode;
  //    modalRef.componentInstance.ActorImageFile == this.CurrentActorProfileController.ActorImageFile;
  //    modalRef.componentInstance.ActorImageFileExtension = this.CurrentActorProfileController.ActorImageFileExtension;

  //    modalRef.result.then(x => { this.GetActorProfileController() })
      
  //  }
  //  else {
  //    alertFunctions.AlertParam('you dont have Permission to Upload...!');
  //  }
  //}
  SelectGrowthCode(s: FollicularScanDetailController) {
    var FollicularGowthcode = s.FollicularGrowth;
    this.printfollicular(FollicularGowthcode);
  }
    Top() {
        let m = document.querySelector("#top");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
        }
    }
    Bottom() {
        let m = document.querySelector("#bottom");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
        }
    }
  ViewMedicines() {
    const modalRef = this.modalService.open(NgbViewMedicineTestModal,
      {
        centered: true,
        size: "lg"

        })
      modalRef.componentInstance.CycleCode = this.CycleCode;
      modalRef.componentInstance.ActorCode = this.ActorCode;
      modalRef.componentInstance.ScanDate = this.CurrentFollicularScanDetailController[0].ScanDate;
  }
    
  printfollicular(FollicularGowthcode: number) {
    this.printService.printDocument2(this.SelectedTreatmentCycle.OwnerFormattedCode, 0

    );
    this.printService.printDocument("follicularscanstcindi",
      {
        ScanCodeData: this.FollicularScanInfo.FollicularGrowth, FollicularGowthcodeData: FollicularGowthcode,
        CycleCode: this.FollicularScanInfo.TreatmentCycle, PatientCode: this.FollicularScanInfo.PatientCode,
        Doc: this.FollicularScanInfo.DOC, DocDate: this.SelectedTreatmentCycle.LMP, CycleActivity: this.FollicularScanInfo.CycleActivity,
        CycleType: this.SelectedTreatmentCycle.CycleType, ScanDate: this.FollicularScanInfo.ScanDate,
        EggSourceData: this.SelectedTreatmentCycle.EggSourceType, DonorData: this.SelectedTreatmentCycle.EggName,
        DonorCode: this.SelectedTreatmentCycle.EggFormattedCode, Owner: this.SelectedTreatmentCycle.OwnerName,
        FormattedCode: this.SelectedTreatmentCycle.OwnerFormattedCode, Protocolst: this.SelectedTreatmentCycle.ProtocolStartDate,
        ProtocolEd: this.SelectedTreatmentCycle.ProtocolEndDate, Protocol: this.SelectedTreatmentCycle.ProtocolName,
        Infertility: this.SelectedTreatmentCycle.InfertilityType, Gender: this.SelectedTreatmentCycle.OwnerGender,
        Age: this.SelectedTreatmentCycle.OwnerAgeYears, CycleNo: this.SelectedTreatmentCycle.CycleNo,

      }

    );
  }
  printfollicular2() {
    this.printService.printDocument2(this.SelectedTreatmentCycle.OwnerFormattedCode, 0

    );
    this.printService.printDocument("follicularscanstc",
      {
        ScanCodeData: this.FollicularScanInfo.FollicularGrowth, CycleCode: this.FollicularScanInfo.TreatmentCycle,
        PatientCode: this.FollicularScanInfo.PatientCode, Doc: this.FollicularScanInfo.DOC, DocDate: this.SelectedTreatmentCycle.LMP,
        CycleActivity: this.FollicularScanInfo.CycleActivity, CycleType: this.SelectedTreatmentCycle.CycleType,
        EggSourceData: this.SelectedTreatmentCycle.EggSourceType, DonorData: this.SelectedTreatmentCycle.EggName,
        DonorCode: this.SelectedTreatmentCycle.EggFormattedCode, Owner: this.SelectedTreatmentCycle.OwnerName,
        FormattedCode: this.SelectedTreatmentCycle.OwnerFormattedCode, Protocolst: this.SelectedTreatmentCycle.ProtocolStartDate,
        ProtocolEd: this.SelectedTreatmentCycle.ProtocolEndDate, Protocol: this.SelectedTreatmentCycle.ProtocolName,
        Infertility: this.SelectedTreatmentCycle.InfertilityType, Gender: this.SelectedTreatmentCycle.OwnerGender,
        Age: this.SelectedTreatmentCycle.OwnerAgeYears, CycleNo: this.SelectedTreatmentCycle.CycleNo,

      }

    );
  }
}
